import { mergeAttributes, Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';

import Component from './data-source-node-view.vue';

export default Node.create({
  name: 'datasource',
  group: 'inline',
  inline: true,
  selectable: true,
  draggable: true,
  atom: true,
  addAttributes() {
    return {
      key: {
        default: 'key'
      },
      sourceFormat: {
        default: undefined
      },
      renderingValue: {
        default: undefined
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: 'datasource'
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['datasource', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return VueNodeViewRenderer(Component);
  }
});
